import { render, staticRenderFns } from "./Adjust.vue?vue&type=template&id=2a2a548d&scoped=true"
import script from "./Adjust.vue?vue&type=script&lang=js"
export * from "./Adjust.vue?vue&type=script&lang=js"
import style0 from "./Adjust.vue?vue&type=style&index=0&id=2a2a548d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2a548d",
  null
  
)

export default component.exports